import { render, staticRenderFns } from "./OsHeader.vue?vue&type=template&id=6ddc08d3&scoped=true"
import script from "./OsHeader.vue?vue&type=script&lang=ts"
export * from "./OsHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddc08d3",
  null
  
)

export default component.exports